import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { oidcConfig } from "./features/auth/openId";
import store from "./features/redux-store/store";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const persistor = persistStore(store);

root.render(
  <AuthProvider {...oidcConfig}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </AuthProvider>,
  // Doc: https://github.com/authts/oidc-client-ts/blob/main/docs/index.md#required-settings
  // https://github.com/authts/sample-keycloak-react-oidc-context/blob/079d739d46521693d55a869e1e0d7109edcf81b8/react/src/config.ts
);

reportWebVitals();
